import { useSelector } from 'react-redux';
import { getTextSearch } from 'store/search';
import { getBadgeSearch } from 'store/search';
import { getQuestionSearch } from 'store/search';

export const useTextSearch = () => useSelector(getTextSearch);
export const useBadgeSearch = () => useSelector(getBadgeSearch);
export const useQuestionSearch = () => useSelector(getQuestionSearch);
